import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { SvgAssets } from '../../../assets/icons/iconSvg';
import c from '../../../constants/Colors';

const ModalLimpiarCarrito = (props) => {
    console.log("ModalLimpiarCarrito====>", props.option, props.visible);
    return (
        <div>
            <Modal returnFocusAfterClose={false} isOpen={props.visible} toggle={() => props.toggle(false)} className='modal_add_cart' centered backdrop="static">
                <ModalHeader>
                    <button className="btn-icon modal-close" onClick={() => props.toggle(false)}><SvgAssets icon="icon-close" fill={c.celeste} /></button>
                    <h6 style={{ color: '#fff' }}>
                        <SvgAssets icon="icon-check" fill={'#fff'} className="mr-3" />
                        Limpiar Carrito
                    </h6>
                </ModalHeader>
                <ModalBody>
                    <div className="cards_scroll">
                        <div key={0} className="card_reemplazo">
                            <div style={{ flex: 1, paddingRight: 10 }}>
                                <div>
                                    <div className="custom-control custom-radio custom-control-inline">
                                        <input id="radio1" name={`radiolimpiar`}
                                            checked={props.option == 'todos'}
                                            onChange={() => props.toggleCheck('todos')}
                                            type="radio" className="custom-control-input" />
                                        <label className="custom-control-label" htmlFor={`radio1`} style={{ color: '#FF9446' }} >Limpiar Todo</label>
                                    </div>
                                    <br />
                                    <br />
                                    <div className="custom-control custom-radio custom-control-inline">
                                        <input id="radio2"
                                            checked={props.option == 'stock'}
                                            onChange={() => props.toggleCheck('stock')}
                                            type="radio" name={`radiolimpiar`} className="custom-control-input" />
                                        <label className="custom-control-label" htmlFor={`radio2`} style={{ color: '#FF9446' }} >Limpiar Sin Stock</label>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className="modal-footer">
                        <button type="button"
                            className={`btn-block${(props.option == '' ? " disabled" : "")}`}
                            disabled={props.option == ''}
                            onClick={() => (props.option == 'todos') ? props.toggleLimpiar(props.carritoProdctos, props.setcarritoProdctos) : props.toggleAceptar(props.carritoProdctos, props.setcarritoProdctos)}
                        >Aceptar</button>
                    </div>
                </ModalBody>
            </Modal>
        </div>
    )
}

export default ModalLimpiarCarrito;